<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import moment from "moment"
import DatePicker from 'vue2-datepicker';

import FeedbackModal from '@components/common/feedback-modal.vue'

import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    FeedbackModal,
    DatePicker
  },
  mixins: [
    Translatable,
  ],
  validations: {
    customerName: {
      required,
    },
  },
  data() {
    return {
      showFeedback: false,
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format("DD/MM/YYYY") : new Date()
        },
      },
      disabledBefore: new Date(),
      modalText: '',
      emitFunc: ''
    }
  },
  computed: {
    ...mapGetters('eShop', [
      'orderData',
      'pdfLink',
      'pageData'
    ]),
    ...mapGetters('cards', [
      'cards',
    ]),
    orderInfo() {
      return this.orderData.order_info ? this.orderData.order_info : {}
    },
    orderCards() {
      const items = this.orderInfo.items.map(item => {
        return this.cards.map(card => card.products.find(product => product.id === item.id))
        .filter(item => item)
        .map(fitem => (
          {
            id: fitem.id,
            name: fitem.name.default,
            count: item.count
          }
        ))
      }).flat()

      return items
    },
    customerName: {
      get () {
        return this.orderData.order_info ? this.orderData.order_info.customer_name : ''
      },
      set (value) {
        this.$v.customerName.$touch()
        this.$store.commit('eShop/updateOrderData', {'customer_name': value});
      }
    },
    arrivalDate: {
      get () {
        const date = this.orderData.order_info ? this.orderData.order_info.pickup_date : new Date()
        return moment(date).toDate()
      },
      set (value) {
        this.$store.commit('eShop/updateOrderData', {'pickup_date': moment(value).format("YYYY-MM-DD")});
      }
    },
    orderDate() {
      const date = this.orderData.order_info ? this.orderData.order_info.timestamp : new Date()

      return {
        date: moment(date).format("DD/MM/YYYY"),
        time: moment(date).format("HH:mm")
      }
    },
    queryData() {
      const query = this.$route.query
      return {
        session_id: query.session_id,
        voucher_number: query.voucher_number,
        type: query.type,
      }
    },
    queryValue() {
      return this.queryData.session_id || this.queryData.voucher_number
    },
    queryKey() {
      return this.queryData.session_id ? 'session_id' : 'voucher_number'
    },
    lang() {
      return ({
        formatLocale: {
          monthsShort: [
            this.getTranslatedContent('CALENDAR_January'),
            this.getTranslatedContent('CALENDAR_February'),
            this.getTranslatedContent('CALENDAR_March'),
            this.getTranslatedContent('CALENDAR_April'),
            this.getTranslatedContent('CALENDAR_May'),
            this.getTranslatedContent('CALENDAR_June'),
            this.getTranslatedContent('CALENDAR_July'),
            this.getTranslatedContent('CALENDAR_August'),
            this.getTranslatedContent('CALENDAR_September'),
            this.getTranslatedContent('CALENDAR_October'),
            this.getTranslatedContent('CALENDAR_November'),
            this.getTranslatedContent('CALENDAR_December'),
          ],
          weekdaysMin: [
            this.getTranslatedContent('CALENDAR_day_Sunday'),
            this.getTranslatedContent('CALENDAR_day_Monday'),
            this.getTranslatedContent('CALENDAR_day_Tuesday'),
            this.getTranslatedContent('CALENDAR_day_Wednesday'),
            this.getTranslatedContent('CALENDAR_day_Thursday'),
            this.getTranslatedContent('CALENDAR_day_Friday'),
            this.getTranslatedContent('CALENDAR_day_Saturday'),
          ],
        }
      })
    }
  },
  created() {
    const status = this.orderInfo.voucher_number ? this.orderInfo.status : null

    if (status !== 0 && status !== 1) {
      this.$router.push({ query: { [this.queryKey]: this.queryValue, type: 'order_accepted' } })
      window.scrollTo(0, 0)
    }
  },
  methods: {
    applyChanges() {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        this.emitFunc = this.applyChanges
        this.toggle('showFeedback')

        if (this.orderInfo.status === 1) {
          this.modalText = this.getTranslatedContent('ESHOP_Manage_modal_changed')

        } else {
          this.modalText = this.getTranslatedContent('ESHOP_Manage_modal_change')

          if (!this.showFeedback) {
            this.$store.dispatch('eShop/editOrder');
            this.$router.push({ query: { [this.queryKey]: this.queryValue, type: 'changed' } })
            window.scrollTo(0, 0)
          }
        }
      }
    },
    cancelOrder() {
      this.modalText = this.getTranslatedContent('ESHOP_Manage_modal_cancel')
      this.emitFunc = this.cancelOrder

      this.toggle('showFeedback')
      if (!this.showFeedback) {
        this.$store.dispatch('eShop/cancelOrder');
        this.$router.push({ query: { [this.queryKey]: this.queryValue, type: 'cancel' } })
        window.scrollTo(0, 0)
      }
    },
    toggle(el) {
      this[el] = !this[el]
      document.body.style.overflow = this.showFeedback ? 'hidden' : ''
    },
    disableDate(date) {
      return date < moment(new Date()).subtract(1, 'd') || date < moment(this.pageData.startDate) || date > moment(this.pageData.endDate)
    },
    cardName(card) {
      return card
      .replace('Day', this.getTranslatedContent('ESHOP_product_name_DAY'))
      .replace('Adult', this.getTranslatedContent('ESHOP_product_name_ADULT'))
      .replace('Child/Student', this.getTranslatedContent('ESHOP_product_name_CHILD_STUDENT'))
      .replace('Card', this.getTranslatedContent('ESHOP_product_name_CARD'))
    },
    statusName(status) {
      return status
      .replace('New', this.getTranslatedContent('ESHOP_OrderStatusNew'))
      .replace('Changed', this.getTranslatedContent('ESHOP_OrderStatusChanged'))
      .replace('PickedUp', this.getTranslatedContent('ESHOP_OrderStatusPickedUp'))
      .replace('Cancelled', this.getTranslatedContent('ESHOP_OrderStatusCancelled'))
    },
    paymentName(status) {
      return status
      .replace('Completed', this.getTranslatedContent('ESHOP_OrderStatusCompleted'))
    },
  },
}
</script>

<template>
    <div class="container">
    <FeedbackModal v-if="showFeedback" :text="modalText" :is-button="true" @toggle="toggle" @emitFunc="emitFunc" />
      <div class="eshop-title">
        <h3 v-html="getTranslatedContent('ESHOP_ManageOrderCaption')">
        </h3>
      </div>
      <div class="parent">
        <div class="content-container">
          <div class="header">
            <p>{{ getTranslatedContent('ESHOP_Manage_summary_title') }}</p>
          </div>
          <div class="content">
            <div class="input-container">
              <label for="status" class="input-title-data">{{ getTranslatedContent('ESHOP_Manage_form_title_status') }}
                <p>{{ statusName(orderInfo.status_name) }}</p>
              </label>
            </div>
            <div class="input-container">
              <label for="payment" class="input-title-data">{{ getTranslatedContent('ESHOP_Manage_form_title_payment') }}
                <p>{{ paymentName(orderData.order_status_name) }}</p>
              </label>
            </div>
            <div class="input-container">
              <label for="voucher" class="input-title-data">{{ getTranslatedContent('ESHOP_Manage_form_title_voucher') }}
                <p>{{ orderInfo.voucher_number }}</p>
              </label>
            </div>
            <div class="input-container">
              <label for="order-date" class="input-title-data">{{ getTranslatedContent('ESHOP_Manage_form_title_date') }}
                <p>{{ `${orderDate.date} ${orderDate.time}` }}</p>
              </label>
            </div>
            <div class="input-container editable">
              <label for="arrival-date" class="input-title">{{ getTranslatedContent('ESHOP_form_date_field') }}
                <DatePicker
                  v-model="arrivalDate"
                  type="date"
                  :formatter="momentFormat"
                  prefix-class="xmx"
                  :editable="false"
                  :clearable="false"
                  :disabled-date="disableDate"
                  :lang="lang"
                />
              </label>
            </div>
            <div class="input-container editable">
              <label for="name" class="input-title">{{ getTranslatedContent('ESHOP_Manage_form_title_name') }}
                <span v-if="$v.customerName.$error && !$v.customerName.required" class="error-message">{{ getTranslatedContent('FORM_validate_required') }}</span>
                <input
                  id="name"
                  v-model="customerName"
                  type="text"
                  :placeholder="getTranslatedContent('REVIEWS_form_name_placeholder')"
                  :class="$v.customerName.$error ? 'error' : ''"
                >
              </label>
            </div>
            <div class="buttons-container">
              <div class="link">
                <button class="button-cancel" @click="applyChanges">{{ getTranslatedContent('ESHOP_buttonText_manage_apply') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="content-container">
            <div class="header">
              <p>{{ getTranslatedContent('ESHOP_Manage_ordered_title') }}</p>
            </div>
            <div class="content">
              <div class="cards-container">
                <div class="cards-title">
                  <p>{{ getTranslatedContent('ESHOP_Manage_ordered_name') }}</p>
                  <p>{{ getTranslatedContent('ESHOP_Manage_ordered_amount') }}</p>
                </div>
                <div v-for="card of orderCards" :key="card.id" class="card-container" >
                  <p class="card-name">{{ cardName(card.name) }}</p>
                  <p class="card-count">{{ card.count }}</p>
                </div>
              </div>
              <p>
                {{ getTranslatedContent('ESHOP_Manage_ordered_text') }}
              </p>
            </div>
          </div>
          <div class="content-container">
            <div class="header">
              <p>{{ getTranslatedContent('ESHOP_Manage_getVoucher_title') }}</p>
            </div>
            <div class="content">
              <p>{{ getTranslatedContent('ESHOP_Manage_getVoucher_text') }}</p>
              <div class="buttons-container">
                <a class="link" :href="pdfLink" download>
                  <button class="button-cancel">{{ getTranslatedContent('ESHOP_buttonText_manage_download') }}</button>
                </a>
              </div>
            </div>
          </div>
          <div class="content-container">
            <div class="header">
              <p>{{ getTranslatedContent('ESHOP_Manage_cancellation_title') }}</p>
            </div>
            <div class="content">
              <p>{{ getTranslatedContent('ESHOP_Manage_cancellation_text') }}</p>
              <div class="buttons-container">
                <div class="link">
                  <button class="button-cancel" @click="cancelOrder">{{ getTranslatedContent('ESHOP_buttonText_manage_cancel') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';
@import '@styles/form.scss';

.parent {
  display: grid;
  grid-template-columns: 367px 751px;
  gap: 20px;
}

.content-container {
  margin-bottom: 20px;
}

.header {
  height: 56px;
  background: $orange;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px 10px 0 0;

  p {
    font-family: Open Sans Bold;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    color: $white;
    text-transform: uppercase;
  }
}

.content {
  // height: 750px;
  background: $light-gray;
  border-radius: 0 0 10px 10px;
  border: 1px solid $dark-gray;
  padding: 21px 16px;

  p {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 23px;
    color: $black;
  }
}

.container {
  min-height: 50vh;
}

.buttons-container {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.eshop-title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-size: 22px;
  line-height: 29px;
  text-transform: uppercase;
  color: $dark-blue;
  margin-bottom: 38px;
  margin-top: 70px;
}

::v-deep .eshop-text {
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  color: $black;

  & a {
    color: $gray;
    text-decoration: none;

    &:hover {
      color: $orange;
    }
  }
}

.link {
  display: block;
  outline: none;
  height: 48px;
}

.button-cancel {
  min-width: 175px;
  height: 48px;
  border: 1px solid $gray;
  border-radius: 5px;
  background: $white;
  color: $black;
  font-family: Open Sans, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  padding: 12px 30px;

  &:hover {
    border: 1px solid $white;
    height: 50px;
    background: $gray;
    color: $white;
  }
}

.cards-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  p {
    font-family: Open Sans Bold;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    color: $black;
  }
}

.card-container {
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: $white;
  border: 1px solid $dark-gray;
  padding: 14px 9px 14px 15px;
  margin-bottom: 3px;

  &:last-child {
    margin-bottom: 20px;
  }

  p {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
    color: $gray;
  }
}

.input-container {
  margin-top: 0;
  margin-bottom: 5px;
  width: auto;
}

@media only screen and (max-width: $screen-width-xs) {
  .parent {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
  }
  .eshop-title {
    font-size: 22px;
    line-height: 29px;
    margin-top: 24px;
    margin-bottom: 20px;
  }

  .content {
    padding: 15px 8px;
  }

  .input-title {
    font-family: Open Sans Bold;
  }

  .input-container {
    margin-top: 3px;
  }

  .buttons-container {
    display: flex;
    flex-direction: column;
    margin-top: 25px;
  }

  .link {
    margin: 0 0 15px;
  }

  .button-cancel {
    min-width: 100%;

    &:hover {
      border: 1px solid $gray;
      height: 48px;
      background: $white;
      color: $black;
    }

    &:active {
      border: 1px solid $white;
      height: 50px;
      background: $gray;
      color: $white;
    }
  }
}
</style>
